import Vue from 'vue'
import axios from './vue-axios/axios'

export function getCompletionOfRequestsStats(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/stats/completion_of_requests`, {
    params: params,
    paramsSerializer: function (params) {
      return $.param(params)
    }
  })
}

export function getResponseByTimeStats(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/stats/response_time`, {
    params: params,
    paramsSerializer: function (params) {
      return $.param(params)
    }
  })
}

export function getOffersByServicesStats(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/stats/offers_grouped_by_services`, {
    params: params,
    paramsSerializer: function (params) {
      return $.param(params)
    }
  })
}

export function getOffersByEntitiesStats(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/stats/offers_grouped_by_entities`, {
    params: params,
    paramsSerializer: function (params) {
      return $.param(params)
    }
  })
}

export function getOffersByOccupationsStats(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/stats/offers_grouped_by_occupations`, {
    params: params,
    paramsSerializer: function (params) {
      return $.param(params)
    }
  })
}

export function getOffersByHubsStats(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/stats/offers_grouped_by_hubs`, {
    params: params,
    paramsSerializer: function (params) {
      return $.param(params)
    }
  })
}

export function getReasonsReplacement(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/stats/reasons_replacement`, {
    params: params,
    paramsSerializer: function (params) {
      return $.param(params)
    }
  })
}


export function topCandidates(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/stats/top_candidates`, {
    params: params,
    paramsSerializer: function (params) {
      return $.param(params)
    }
  })
}

export function getActivityCandidates(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/global_stats/activity_candidates`, {
    params: params,
    paramsSerializer: function (params) {
      return $.param(params)
    }
  })
}

export function getUsingChannels(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/global_stats/using_channels`, {
    params: params,
    paramsSerializer: function (params) {
      return $.param(params)
    }
  })
}

export function getCandidateEvolution(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/global_stats/candidate_evolution`, {
    params: params,
    paramsSerializer: function (params) {
      return $.param(params)
    }
  })
}



// WEBPACK FOOTER //
// ./src/backend/stats.js